import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Sidebar/sgds-sidebar-section";
import { register } from "../../utils/ce-registry";

register("sgds-sidebar-section", Component);

export default createComponent({
  react: React,
  tagName: "sgds-sidebar-section",
  elementClass: Component,
  events: {}
});
